import TemplateView from "../TemplateView";
import TypeOfWorkEmptyListPlaceholder from "./TypeOfWorkEmptyListPlaceholder";
import {typeOfWorkComparator} from "./utils";

export default class TypesOfWorkList extends TemplateView {
    constructor({
        nodeRenderer = null,
    }) {
        super()

        this.state = {
            typesOfWork: [],
            searchText: ''
        }

        this.params = {
            nodeRenderer,
        }

        this.onAnyStatePropertyDeeplyChanged(['typesOfWork','searchText'], () => {
            this._renderTypesOfWork()
        })
    }

    templateHtml() {
        return '<div class="typeOfWorkList">' +
               '</div>'
    }

    _renderTypesOfWork() {
        this.$el.empty()

        if (this.state.typesOfWork.length) {
            this.state.typesOfWork.sort(typeOfWorkComparator).forEach(typeOfWork => {
                this.params.nodeRenderer(this.$el, typeOfWork, this.state.searchText)
            })
        } else {
            new TypeOfWorkEmptyListPlaceholder().init(this.$el)
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/typesOfWork/TypesOfWorkList.js